var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCompetitionWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 15,
    viewBox: "0 0 14 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.8628 3.50967L12.2722 0.91709L6.99997 0.606445L1.72771 0.919994L2.13707 3.51254H0.0322266V3.80286C0.0322266 7.44645 2.96743 10.4164 6.59646 10.4774C6.24219 11.4413 5.11001 13.9641 2.93545 13.9641V14.5448H11.0645V13.9641C8.88993 13.9641 7.75775 11.4413 7.40348 10.4774C11.0325 10.4164 13.9677 7.44645 13.9677 3.80286V3.51254H11.8628V3.50967ZM6.99997 1.18709L11.5987 1.45999L11.0732 4.78415C10.6841 7.24608 9.2442 9.89677 6.99997 9.89677C4.75581 9.89677 3.35932 7.32737 2.9267 4.78415L2.40126 1.45999L6.99997 1.18709ZM0.618678 4.09032H2.22997L2.35481 4.87705C2.7467 7.18802 3.62061 8.66286 4.61065 9.51641C2.36642 8.68903 0.737711 6.58709 0.618678 4.09032ZM9.19481 13.9613H4.80807C5.94614 13.2035 6.64872 11.8738 7.00283 11.0319C7.35416 11.8738 8.05674 13.2035 9.19767 13.9613H9.19481ZM9.37481 9.52221C10.5884 8.44515 11.3694 6.61612 11.6451 4.87419L11.77 4.09032H13.3813C13.2622 6.5929 11.6277 8.70064 9.37767 9.52221H9.37481Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCompetitionWhite);
export default __webpack_public_path__ + "static/media/competition-white.a555bc397e919b1d80a8481a6282cdb7.svg";
export { ForwardRef as ReactComponent };